import { render } from "./WeatherImg.vue?vue&type=template&id=37a15fa1"
import script from "./WeatherImg.vue?vue&type=script&lang=js"
export * from "./WeatherImg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__